import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' }
});

// Attach stored token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 — try refresh once, never hard-redirect
api.interceptors.response.use(
  res => res,
  async (error) => {
    if (error.response?.status === 401 && !error.config._retry) {
      error.config._retry = true;
      try {
        const token = localStorage.getItem('access_token');
        const { data } = await axios.post(`${API}/auth/refresh`, {}, {
          headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        });
        if (data.access_token) {
          localStorage.setItem('access_token', data.access_token);
          error.config.headers['Authorization'] = `Bearer ${data.access_token}`;
        }
        return api(error.config);
      } catch {
        // Don't hard redirect — let AuthContext handle navigation
        localStorage.removeItem('access_token');
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export function formatError(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).filter(Boolean).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
